<template>
	<section class="section-maker">
		<div class="container">
			<div class="sec-maker-header text-center">
				<h3 class="sec-maker-h3">{{ title }}</h3>
			</div>
			<div class="wrapper-content">
				<div class="outer-area-tab">
					<div class="tab-content">
						<!-- BEST SELLER PRODUCTS -->
						<div class="tab-pane active show fade" id="men-latest-products">
							<div class="row">
								<div class="row w-100" v-if="getStatus[type].loading">
									<div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="i in 4" :key="i">
										<div class="item">
											<content-loader
												viewBox="0 0 400 500"
												:speed="2"
												primaryColor="#f3f3f3"
												secondaryColor="#ecebeb"
											>
												<rect x="0" y="0" rx="0" ry="0" width="400" height="292" />
												<rect x="20" y="325" rx="0" ry="0" width="85" height="13" />
												<rect x="20" y="349" rx="0" ry="0" width="297" height="19" />
												<rect x="20" y="379" rx="0" ry="0" width="293" height="31" />
												<rect x="20" y="427" rx="0" ry="0" width="73" height="40" />
											</content-loader>
										</div>
									</div>
								</div>
								<Product
									v-for="product in getProducts[type].data.slice(0, 4)"
									:key="product.id"
									:product="product"
									v-else
								/>
							</div>
							<div
								class="product-not-found"
								v-if="getProducts[type].total == 0 && !getStatus[type].loading"
							>
								<div class="not-found">
									<h2>COMING SOON!</h2>
									<h6>
									   Something new is in its way.
										<a href="/profile" style="color: #343a40"></a>
									</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
			v-if="getProducts[type].total > 4 && !getStatus[type].loading"
		>
			<router-link
				class="redirect-link"
				:to="{name: 'ProductsByType', params: {type: type}}"
				>View more on this category</router-link
			>
		</div>
		<div
			class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-30"
			v-else
		></div>
	</section>
</template>

<script>
	import Spinner from "../Loaders/Spinner.vue";
	import Product from "../Sections/Products/Product.vue";
	import {mapActions, mapGetters} from "vuex";
	import {ContentLoader} from "vue-content-loader";
	export default {
		props: ["title", "type"],
		components: {
			Spinner,
			Product,
			ContentLoader,
		},
		computed: {
			...mapGetters("products", ["getProducts", "getStatus"]),
			...mapGetters("auth", ["isLoggedIn"]),
		},
		data() {
			return {
				products: [],
				loading: false,
				selectedProductType: "",
			};
		},
		methods: {
			...mapActions("products", [
				"fetchProducts",
				"getBestSellerProducts",
				"getNewArrivals",
				"getFeaturedProducts",
				"getTopLiked",
			]),
		},
		mounted() {
			if (this.type == "featured") {
				this.getFeaturedProducts();
			} else if (this.type == "best_seller") {
				this.getBestSellerProducts();
			} else if (this.type == "top_liked") {
				this.getTopLiked();
			} else if (this.type == "new_arrival") {
				this.getNewArrivals();
			}
		},
	};
</script>

<style scoped>
	.disabled {
		color: grey !important;
		pointer-events: none;
	}
	.nav-link.active.disabled {
		border-color: grey !important;
	}
	.nav-link.disabled:after {
		background-color: grey !important;
	}
	.sec-maker-h3 {
		border-bottom: 4px solid #343a40;
		display: inline-block;
	}
	/* .nav-link{
  color: grey !important;
  pointer-events: none;

}
.nav-link.active {
  border-color: grey !important;
}
.nav-link:after{
  background-color: grey !important;
} */
</style>
